import React, { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'i18n'
import UploadProgressBar from './UploadProgressBar'

import UploadButton from './UploadButton'
import filestackUploader from './filestack-uploader.js'
import './Uploads.scss'
import UploadByCamera from 'components/UploadByCamera'

const VideoPreview = ({ file }) => {
  let videoRef = useRef(null)
  useEffect(() => {
    try {
      if (videoRef.current) {
        videoRef.current.src = URL.createObjectURL(file)
        videoRef.current.load()
        videoRef.current.play()
      }
    } catch (e) {
      console.log(e)
    }
  }, [file])
  return (
    <>
      <div className={`video-overlay`}>
        <video muted loop ref={videoRef} />
      </div>
    </>
  )
}

//processes image as b64 thumbnail
const processImageToBase64 = inputFile => {
  const temporaryFileReader = new FileReader()

  return new Promise((resolve, reject) => {
    temporaryFileReader.onerror = () => {
      temporaryFileReader.abort()
      reject(new DOMException('Problem parsing input file.'))
    }
    temporaryFileReader.onload = () => {
      resolve(temporaryFileReader.result)
    }
    temporaryFileReader.readAsDataURL(inputFile)
  })
}

const Upload = ({ file, onSuccess, onRemove, onFileSelection }) => {
  const { t } = useTranslation('ugcMediaUpload')
  const [uploadProgress, setUploadProgress] = useState(null)
  const [uploadSuccess, setUploadSuccess] = useState(false)
  const [uploadError, setUploadError] = useState(false)
  const [type, setType] = useState(null)

  const [thumbnail, setThumbnail] = useState(null)

  const handleError = error => {
    console.log(`handleError`, error)
    if (typeof error === 'string') {
      setUploadError(error)
    } else {
      console.log(`error not string`, error)
      setUploadError('error')
    }
  }
  const handleProgress = progress => {
    setUploadProgress(progress)
  }

  const handleSuccess = success => {
    console.log(`handleSuccess`, success)
    setUploadSuccess(true)

    setUploadProgress(100)

    onSuccess(success)
  }
  const cleanNameStr = str => {
    try {
      let cleanerStr = str.split(' ').join('-').split('+').join('-')
      return `mediaupload--${cleanerStr}`
    } catch (e) {
      return str
    }
  }
  const handleUpload = file => {
    console.log(`handleUpload`, file)
    //in order to get AWS lambda function to work,
    //we need to prefix the file name with the string "mediaupload--".
    //additionally, we've had issues with spaces, as well as their equivalent in ascii (+)
    let prefixedName = cleanNameStr(file.name)
    filestackUploader({
      file,
      prefixedName,
      onError: function (error, client) {
        console.log(`error`, error)
        handleError('error')
      },
      onProgress: handleProgress,
      onSuccess: handleSuccess,
    })
  }

  useEffect(() => {
    if (file) {
      console.log(`useeffect file change`, file)

      setUploadProgress(0)
      if (file.type.indexOf('video') > -1) {
        setType('video')
        handleUpload(file)
      } else {
        setType('image')

        handleUpload(file)
        processImageToBase64(file).then(data => {
          setThumbnail(data)
        })
      }
      //  }
    } else {
      console.warn(`no file`)
    }
  }, [file])

  const fileName = () => {
    try {
      return file.name
    } catch (e) {
      return 'File'
    }
  }

  const handleRemove = (index = 0) => {
    console.log(`remove`)
    setUploadProgress(0)
    setUploadSuccess(false)
    setUploadError(false)
    setThumbnail(null)
    setType(null)
    onRemove(index)
  }

  return (
    <li
      className={`image-preview upload new-upload-box ${
        uploadError && uploadError ? 'upload-error' : ''
      }`}
      style={
        thumbnail
          ? {
              backgroundImage: `url(${thumbnail})`,
            }
          : {
              backgroundColor: `#000`,
            }
      }
    >
      {type === 'video' && uploadError === false && (
        <VideoPreview
          active={type === 'video' && uploadError === false}
          file={file}
        />
      )}
      <div
        className={`uploaded-image-item-info review-view`}
        style={{ gap: '15px' }}
      >
        {uploadError || file === null ? (
          <>
            {uploadError && (
              <div className={`upload-error`}>
                {t('upload.errorUploading', { error: uploadError })}
              </div>
            )}
            <UploadButton
              onFileSelection={onFileSelection}
              maxFiles={1}
              label={t('upload.reUpload')}
              onError={handleError}
              className="btn themed-button"
            />
            <UploadByCamera
              onUpload={onFileSelection}
              onError={handleError}
              className="receipt-upload-button"
              buttonClassName="btn themed-button"
              mediaAccepted={[`image/*`, 'video/*']}
            />
          </>
        ) : (
          <>
            <div
              className={`uploaded-image-remove x-button`}
              onClick={handleRemove}
            ></div>
            <UploadProgressBar percent={uploadProgress} />
            <div className={`uploaded-image-item-name`}>{fileName()}</div>
          </>
        )}
      </div>
    </li>
  )
}

const Uploads = ({
  files,
  onSuccess,
  onRemove,
  onError,
  handleFileSelection,
}) => {
  const handleError = error => {
    console.log(`handleError`, error)
    onError(error)
  }
  return (
    <>
      <ul className={`uploaded-image-list`}>
        {files.length > 0 ? (
          files.map((file, i) => {
            return (
              <Upload
                onFileSelection={handleFileSelection}
                onError={handleError}
                file={file}
                onRemove={onRemove}
                onSuccess={onSuccess}
                key={i}
              />
            )
          })
        ) : (
          <Upload
            onFileSelection={handleFileSelection}
            onError={handleError}
            file={null}
            onRemove={onRemove}
            onSuccess={onSuccess}
          />
        )}
      </ul>
    </>
  )
}

export default Uploads
